export enum ECustomerServerProvisionStates {
	ADAPTIVA_CDN_STATUS_NOT_PROVISIONED = 0,
	ADAPTIVA_CDN_STATUS_PROVISION_REQUESTED = 1,
	ADAPTIVA_CDN_STATUS_OPERATION_IN_PROGRESS = 2,
	ADAPTIVA_CDN_STATUS_PROVISIONED_ENABLED = 3,
	ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLE_REQUESTED = 4,
	ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLED = 5,
	ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLED_ENABLE_REQUESTED = 6,
	ADAPTIVA_CDN_STATUS_PROVISIONED_UNPROVISION_REQUESTED = 7
}
